var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('div',{staticClass:"login-container"},[_c('app-updated-alert',{attrs:{"auth":!_vm.isMasterLogin,"auth-like":_vm.isMasterLogin}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('vue-snotify')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }